module.exports = __webpack_public_path__ + "static/media/sharan.515a853d.png";